// tanstack
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/analysis/',
)({
  beforeLoad: () =>
    redirect({
      to: 'overview',
      replace: true,
    }),
});
